import { render, staticRenderFns } from "./priceformat.vue?vue&type=template&id=a0874f2e&"
import script from "./priceformat.vue?vue&type=script&lang=js&"
export * from "./priceformat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0874f2e')) {
      api.createRecord('a0874f2e', component.options)
    } else {
      api.reload('a0874f2e', component.options)
    }
    module.hot.accept("./priceformat.vue?vue&type=template&id=a0874f2e&", function () {
      api.rerender('a0874f2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2WFwAkAA1Ffze/JS/priceformat.vue"
export default component.exports